import { jsx as _jsx } from "react/jsx-runtime";
import Amt from '@/common/components/amt';
export const sectionLabel = (type) => type === 'income' ? 'Доходы' : type === 'savings' ? 'Накопления' : 'Расходы';
export const typeColor = (type) => type === 'income' ? 'var(--income)' : type === 'savings' ? 'var(--savings)' : 'var(--expense)';
export const deltaColor = (delta) => {
    if (delta === 0)
        return 'var(--text-3)';
    return delta > 0 ? 'var(--income)' : 'var(--expense)';
};
export const remainderLabel = (type) => type === 'income' ? 'Недополучка' : type === 'expense' ? 'Перерасход' : 'Остаток';
/**
 * Чистая логика крайнего столбца отклонения. Единая для всех групп:
 * отклонение в «хорошую» сторону → зелёное с «+», в «плохую» → красное с «−».
 *
 * - Доходы/Накопления: хорошо, когда факт > план.
 * - Расходы: хорошо, когда факт < план (экономия).
 *
 * Знак показывается всегда. Случай «плана нет, но есть факт» (planned === 0)
 * тоже даёт значение со знаком (раньше показывался «—»).
 */
export function deltaInfo(type, planned, actual) {
    if ((planned === 0 && actual === 0) || actual === planned) {
        return { isDash: true, magnitude: 0, sign: '', color: 'var(--text-3)' };
    }
    const good = type === 'expense' ? actual < planned : actual > planned;
    const factColor = planned === 0
        ? (type === 'expense' ? 'var(--expense)' : 'var(--income)')
        : undefined;
    return {
        isDash: false,
        magnitude: Math.abs(actual - planned),
        sign: good ? '+' : '−',
        color: good ? 'var(--income)' : 'var(--expense)',
        factColor,
    };
}
export function calcDelta(type, planned, actual, currency) {
    const info = deltaInfo(type, planned, actual);
    if (info.isDash)
        return { text: '—', color: info.color, factColor: info.factColor };
    return {
        text: _jsx(Amt, { value: info.magnitude, currency: currency, sign: info.sign }),
        color: info.color,
        factColor: info.factColor,
    };
}
